import { TextareaAutosize } from '@mui/material'
import { ButtonBase, styled as muiStyled } from '@mui/material'
import { AsyncPaginate, withAsyncPaginate } from 'react-select-async-paginate'
import { default as Creatable } from 'react-select/creatable'
import { isValidNumber } from 'src/consumer/helpers/utilFunctions'
import { MUIThemeConfig } from 'src/context/MUIThemeConfig'
import styled from 'styled-components'
import { PRESCRIPTION_COLORS_MAP } from './inputComponents/common/color-utils'

const getFooterBackground = ({ noColor, accentColor = '#397c73', debug = false }) => {
  if (debug) {
    return 'transparent'
  }
  if (noColor) {
    return '#FFF'
  }
  return accentColor
}

export const PrescriptionTabFinalParent = styled.div`
  height: auto;
  min-height: auto;
  padding: 4px;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  box-sizing: border-box;
  position: relative;
  @media (max-width: 768px) {
    padding: 4px 8px;
    min-height: auto;
  }
  @media print {
    padding: 0px !important;
    .hide-on-print {
      display: none !important;
    }
    .hide-on-print-only {
      display: none !important;
    }
    .make-all-borders-black-print {
      border: 1px solid rgba(0, 0, 0, 0.15);
    }
    /* Hide all UI elements, buttons, and debug labels */
    button,
    [class*="MuiButton"],
    [class*="MuiIconButton"],
    [class*="MuiBackdrop"],
    [class*="MuiDrawer"]:not([class*="print"]),
    [class*="MuiDialog"],
    [class*="MuiModal"],
    input[type="button"],
    input[type="submit"],
    a[role="button"],
    /* Hide debug labels and floating elements */
    div[style*="position: absolute"][style*="right"],
    div[style*="position:absolute"][style*="right"],
    div[style*="position: fixed"],
    div[style*="position:fixed"],
    /* Hide scrollbars */
    ::-webkit-scrollbar {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      width: 0 !important;
    }
    /* Ensure proper page breaks */
    * {
      page-break-inside: avoid;
    }
    h1, h2, h3, h4, h5, h6 {
      page-break-after: avoid;
    }
    table {
      page-break-inside: avoid;
    }
    @page {
      size: A4;
      orientation: portrait;
      margin: 0;

      /* Enable background graphics */
      -webkit-print-color-adjust: exact; /* For Chrome */
      print-color-adjust: exact; /* For other browsers */
    }
    /* Ensure body and html are clean for printing */
    html, body {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      height: auto !important;
      overflow: visible !important;
    }
  }
`

//

export const PMPParent = styled.div`
  ${({ hiddenInUI }) => hiddenInUI && 'display: none !important;'}
  @media print {
    display: block !important;
  }
  @page {
    size: A4 portrait; /* Page size and orientation */
    margin-top: 1in; /* Top, right, bottom, left */
  }
  margin: 0px auto;
  border: ${(props) => (props?.noBorder ? '' : '1px solid rgba(0, 0, 0, 0.15)')};
  width: 100%;
  max-width: 794px;
  // min-height: 300px;
  height: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box; /* Ensure borders are included in the width */
  font-size: ${({ biggerFont }) => (biggerFont ? '17px' : '12px')};
  background: #fff;
  color: #000;
`

export const PMPParentVarTwo = styled.div`
  margin: 20px auto;
  border: 1px solid black;
  width: 100%;
  max-width: 210mm;
  height: auto;
  display: flex;
  flex-direction: row;
  font-size: 13px;
  background: #fff;
`

export const PMPHeadingBanner = styled.div`
  width: 100%;
  background: ${({ noColor, debug }) => {
    if (debug) {
      return 'transparent'
    }
    if (noColor) {
      return '#FFF'
    }
    return '#397c73'
  }};
  text-align: center;
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  color: ${(props) => (props?.noColor ? '#000' : '#FFF')};
  border-bottom: 1px solid #000;
  letter-spacing: 1.5px;
  font-weight: 700;
  font-size: 18px;
  padding: 2px;
  .sub-heading {
    font-size: 12px;
    margin-top: 4px;
    text-transform: none;
  }
`

export const PMPButtonsContainer = styled.div`
  display: flex;
  flex-direction: ${({ alwaysInRow }) => (alwaysInRow ? 'row' : 'column')};
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 20px 0;
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 2;
  @media (min-width: 1080px) {
    flex-direction: row;
    gap: unset;
  }
`

export const PMPButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props?.whitebg ? '#fff' : '#0098ff')};
  color: ${(props) => (props?.whitebg ? '#0098ff' : '#fff')};
  padding: 2px 10px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 30px;
  border: 1px solid #0098ff;
`

export const PMPButtonForConsultation = muiStyled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'whitebg',
})(
  ({ theme, whitebg }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${whitebg ? '#fff' : theme.palette.emrSecondary.default};
  color: ${whitebg ? theme.palette.emrSecondary.default : '#fff'};
  padding: 2px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 24px;
  border: 1px solid ${theme.palette.emrSecondary.default};
  gap:4px;
  &:active {
    transform: none !important;
    transition: none !important;
  }
`,
)

///

export const PMPHeaderLeftPart = styled.div`
  width: 50%;
  padding: 5px 20px;
`

export const PMPHeaderRightPart = styled.div`
  width: 50%;
  padding: 5px 20px;
  display: flex;
  flex-direction: column;
  align-items: end;
`

export const PMPHeaderDoctorText = styled.div`
  color: ${(props) => (props?.main ? '#000' : '#080808')};
  font-weight: ${(props) => (props?.main ? '600' : '400')};
  font-size: ${(props) => (props?.main ? '14px' : '12px')};
  ${(props) => props?.textRight && `text-align: right`};
`

export const PMPHeaderDetails = styled.div`
  background: ${({ noColor, debug }) => {
    if (debug) {
      return 'transparent'
    }
    if (noColor) {
      return '#FFF'
    }
    return MUIThemeConfig.palette.emrPrescriptionPrimary.default
  }};
  padding: 5px 20px;
  color: #000;
  border-bottom: 1px solid #000;
`

//

export const PMPFooterContainer = styled.div`
  background: ${(props) => getFooterBackground(props)};
  padding: 5px 20px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  border-top: 1px solid #000;
  box-sizing: border-box;
`

export const PMPColumnedFooter = styled.div`
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props?.columns || 3}, 1fr)`};
  border-top: 1px solid #000;
  background: ${(props) => getFooterBackground(props)};
  color: ${(props) => (props?.noColor ? '#000' : '#FFF')};
`

//

export const PMPLockedSection = styled.div`
  width: 350px;
  flex-shrink: 0;
  margin-top: 20px;
  border: 1px solid #a2a2a2;
  border-radius: 10px;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const PMPSingleRowForDrugs = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  border: ${({ isHeaderRow, useGreyBorders, colorMode }) => {
    if (colorMode === 'bw') {
      return isHeaderRow
        ? '1px solid rgba(0, 0, 0, 0.3)'
        : useGreyBorders
          ? '1px solid rgba(0, 0, 0, 0.15)'
          : '1px solid rgba(0, 0, 0, 0.2)'
    }
    return isHeaderRow
      ? '1px solid rgba(67, 56, 202, 0.4)'
      : useGreyBorders
        ? '1px solid rgba(67, 56, 202, 0.15)'
        : '1px solid rgba(67, 56, 202, 0.25)'
  }};
  ${({ isLastRow }) => (isLastRow ? '' : 'border-bottom: unset;')}
  font-weight: ${({ isHeaderRow }) => (isHeaderRow ? '600' : '400')};
  ${({ isCellCapitalized }) => (isCellCapitalized ? 'text-transform: uppercase' : '')};
  ${({ areCellsBold }) => areCellsBold && 'font-weight: 700;'}
  background: ${({ isHeaderRow, colorMode, rowIndex }) => {
    if (isHeaderRow) {
      if (colorMode === 'bw') {
        return '#e8e8e8'
      }
      return 'linear-gradient(135deg, rgba(67, 56, 202, 0.12) 0%, rgba(99, 102, 241, 0.12) 100%)'
    }
    // Alternate row shades
    if (colorMode === 'bw') {
      return rowIndex % 2 === 0 ? '#ffffff' : '#f5f5f5'
    }
    // Colored mode with alternating shades
    return rowIndex % 2 === 0 
      ? 'rgba(255, 255, 255, 1)' 
      : 'rgba(67, 56, 202, 0.04)'
  }};
  transition: all 0.2s ease;
  ${({ isHeaderRow, colorMode }) =>
    !isHeaderRow &&
    colorMode !== 'bw' &&
    `
    &:hover {
      background: rgba(67, 56, 202, 0.08);
      border-color: rgba(67, 56, 202, 0.3);
    }
  `}
  /* Removed min-width to prevent horizontal scrollbar */
`

export const PMPSingleRowForDiagnosis = styled.div`
  width: 100%;
  display: flex;
  border: ${({ isHeaderRow, useGreyBorders }) =>
    isHeaderRow
      ? '1px solid rgba(67, 56, 202, 0.2)'
      : useGreyBorders
        ? '1px solid rgba(67, 56, 202, 0.1)'
        : '1px solid rgba(67, 56, 202, 0.15)'};
  ${({ isLastRow }) => (isLastRow ? '' : 'border-bottom: unset;')}
  font-weight: ${({ isHeaderRow }) => (isHeaderRow ? '600' : '400')};
  ${({ isCellCapitalized }) => (isCellCapitalized ? 'text-transform: uppercase' : '')};
  ${({ areCellsBold }) => areCellsBold && 'font-weight: 700;'}
  background: ${({ isHeaderRow }) =>
    isHeaderRow
      ? 'linear-gradient(135deg, rgba(67, 56, 202, 0.08) 0%, rgba(99, 102, 241, 0.08) 100%)'
      : 'transparent'};
  transition: all 0.2s ease;
  ${({ isHeaderRow }) =>
    !isHeaderRow &&
    `
    &:hover {
      background: rgba(67, 56, 202, 0.03);
      border-color: rgba(67, 56, 202, 0.2);
    }
  `}
`

export const PMPSingleRowBox = styled.div`
  /* Include padding + the right border inside the declared width%. Without this the
     editor table's header cells (which have padding + a 1px border) rendered ~17px
     wider than the plain-div body cells, so header labels drifted right of their
     columns. The print table already passes boxSizing:'border-box' inline, so this is
     a no-op there and only corrects the editor/diagnosis header-vs-body alignment. */
  box-sizing: border-box;
  background: ${(props) => {
    if (props?.colorMode === 'bw') {
      return props?.whiteBG ? '#FFFFFF' : props?.isHeaderRow ? 'transparent' : '#fafafa'
    }
    // Default to colored mode if colorMode is undefined (for editor components)
    return props?.whiteBG
      ? '#FFFFFF'
      : props?.isHeaderRow
        ? 'transparent'
        : 'linear-gradient(135deg, rgba(67, 56, 202, 0.03) 0%, rgba(99, 102, 241, 0.03) 100%)'
  }};
  color: ${(props) => {
    if (props?.colorMode === 'bw') {
      return props?.isHeaderRow ? '#000000' : '#1e293b'
    }
    // Default to colored mode if colorMode is undefined (for editor components)
    // Always use dark colors to ensure visibility on light backgrounds, even in dark mode browsers
    return props?.isHeaderRow ? '#1e3a8a' : '#0f172a'
  }};
  color-scheme: light;
  display: ${(props) => (props?.noFlex ? 'block' : 'flex')};
  align-items: center;
  padding: ${(props) => (props?.noPadding ? '0px' : props?.isHeaderRow ? '12px 8px' : '10px 8px')};
  ${(props) => {
    if (props?.borderRight) {
      if (props?.colorMode === 'bw') {
        return `border-right: 1px solid ${props?.isHeaderRow ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`
      }
      return `border-right: 1px solid ${props?.isHeaderRow ? 'rgba(67, 56, 202, 0.2)' : 'rgba(67, 56, 202, 0.1)'}`
    }
    return ''
  }};
  ${({ isCellCapitalized }) => isCellCapitalized && 'text-transform: uppercase;'}
  ${({ isCellBold }) => isCellBold && 'font-weight: 700;'}
  justify-content: ${(props) => props?.centered && 'center'};
  word-break: break-word;
  font-size: ${(props) => (props?.isHeaderRow ? '14px' : '14px')};
  font-weight: ${(props) => (props?.isHeaderRow ? '700' : '400')};
  flex-shrink: 0;
  min-width: 0; /* Allow flex items to shrink below content size */
`

// general styles for prescription making page items

export const PMPSectionHeading = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: underline;
`

export const PMPSectionHeadingTabView = styled.div`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  text-decoration: underline;
`

export const PMPSectionInputLabel = styled.div`
  min-width: 150px;
  max-width: 500px;
  flex-shrink: 0;
  font-weight: ${(props) => (props?.main ? '700' : '500')};
  font-size: 16px;
`

export const PMPSectionInputBox = styled.input`
  padding: 8px;
  width: 100%;
  max-width: 700px;
  border: 1px solid ${(props) => (props?.required && !props?.value ? '#d32f2f' : '#b4b7ba')};
  border-radius: 2px;
  &:focus {
    outline: 1px solid #7450aa;
  }
`

export const PMPSectionTextAreaBox = styled(TextareaAutosize)`
  padding: 5px 5px;
  width: 100%;
  min-height: 80px;
  // max-width: 700px;
  border: 1px solid ${(props) => (props?.required && !props?.value ? '#d32f2f' : '#b4b7ba')};
  border-radius: 5px;
  &:focus {
    border-color: green;
    outline: none;
  }
`

export const SectionSecondaryHeadingAndContent = styled.div`
  display: flex;
  gap: 2px;
  flex-direction: column;
  padding-right: 60px;
  @media (min-width: 768px) {
  }
`

// styled for prescription dropdowns
const CreatableAsyncPaginate = withAsyncPaginate(Creatable)

export const InstructionsSelect = muiStyled(CreatableAsyncPaginate)(
  ({ theme }) => `
  .instructions_selection__menu{
  position: unset !important;
  box-shadow: unset!important;
  border: 1px solid #c0c0c0;
  }
  .instructions_selection__menu-list{
  max-height: 300px!important;
  height: 100% !important}
`,
)

export const ComplaintCreatableSelect = muiStyled(CreatableAsyncPaginate)(({ theme }) => ``)

export const DiagnosisCreatableSelect = muiStyled(CreatableAsyncPaginate)(
  ({ theme }) => `
  .diagnosis_table_selection__input{
    opacity: 1 !important;
  }
`,
)

export const DiagnosisDurationSelect = muiStyled(AsyncPaginate)(({ theme }) => ``)

export const AssessmentCreatableSelect = muiStyled(CreatableAsyncPaginate)(({ theme }) => ``)
export const AssessmentAsyncSelect = muiStyled(AsyncPaginate)(({ theme }) => ``)

export const ObservationsCreatableSelect = muiStyled(CreatableAsyncPaginate)(({ theme }) => ``)

export const InvestigationsCreatableSelect = muiStyled(CreatableAsyncPaginate)(
  ({ theme }) => `
  width: 100%;
`,
)

export const AdviceCreatableSelect = muiStyled(CreatableAsyncPaginate)(({ theme }) => ``)

export const ObservationsAdvicesComplaintsAndPrescriptionsContainer = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: 20px;
  
`,
)

export const DoconPageItemsContainer = muiStyled('div')(
  ({ theme, singleItem }) => `
  display: grid;
  grid-template-columns: ${singleItem ? '1fr' : '1fr 1fr'};
  flex-grow: 1;
  height: calc(100vh - 133px - 85px);
`,
)

export const DoconPageSingleItemContainer = muiStyled('div')(
  ({ theme, rightBorder }) => `
  padding: 7px;
  border-right: ${rightBorder ? '1px solid #c6c6c6' : 'none'};
  // max-height: calc(100vh - 200px);
  height: 100%;
  overflow-y: scroll;
`,
)

export const PMPCalendarContainer = styled.div`
  width: 220px;
  .react-calendar {
    font-size: 12px;
  }
  .react-calendar__navigation {
    font-size: 12px;
  }
  .react-calendar__navigation__label__labelText {
    font-size: 12px;
  }
  .react-calendar__navigation__label__labelText--from {
    font-size: 12px;
  }
`

export const PMPV2FooterContainer = muiStyled('div')(
  ({ theme, debug, prescriptionWidth = 100 }) => `
    background: ${debug ? PRESCRIPTION_COLORS_MAP.footer.color : 'unset'};
    width: 100%;
    overflow:hidden;
    box-sizing: border-box; 
    flex-shrink: 0;
    // @media print {
    //   position: fixed;
    //   bottom: 0px;
    //   left: 0px;
    //   height: fit-content;
    //   z-index: 2000;
    //   border-bottom: 1px solid #000;
    //   border-left: 1px solid #000;
    //   border-right: 1px solid #000;  
    //   max-width: ${prescriptionWidth}px; /* Adjust width to fit the printable area */
    //   box-sizing: border-box; /* Ensure borders are included in the width */
    // }
  `,
)

export const PmpHeaderContainer = muiStyled('div')(
  ({ theme, debug, headerHeight }) => `
    background: ${debug ? PRESCRIPTION_COLORS_MAP.header.color : '#FFF'};
    flex-shrink: 0;
    overflow: hidden;
    border-bottom: ${isValidNumber(headerHeight) && headerHeight === 0 ? '' : '1px solid #000'};
    // @media print {
    //     position: fixed;
    //     top: 0px;
    //     left: 0px;
    //     border-top: 1px solid #000;
    //     border-bottom: 1px solid #000;
    //     border-left: 1px solid #000;
    //     border-right: 1px solid #000; 
    //     z-index: 1000; /* Make sure it stays above content */
    // }
  `,
)

export const PmpContentContainer = muiStyled('div')(
  ({ theme, noPadding = false }) => `
        flex: 1;
        padding: ${noPadding ? '0px' : '10px 20px'};
        `,
)

export const PmpConsultationContentContainer = muiStyled('div')(
  ({ theme }) => `
  flex: 1;
  padding: 0px 20px;
  `,
)

export const PmpBodyContentContainer = muiStyled('div')(
  ({ theme, debug, headerHeight = 114, footerHeight = 114 }) => `
      background: ${debug ? PRESCRIPTION_COLORS_MAP.bodyColor.color : 'unset'};
      display: flex;
      flex-direction: column;
      flex-grow: 1;
        @media print {
          // padding-top: ${headerHeight}px; /* Adjust this value to match the header height */
          // padding-bottom: ${footerHeight}px;
          margin: 0; /* Remove default margin */
          // page-break-inside: avoid; /* Avoid breaking content inside the body */
          box-sizing: border-box;
        }
  `,
)

export const PmpConsultationBodyContentContainer = muiStyled('div')(
  ({ theme, debug, headerHeight = 114, footerHeight = 114 }) => `
    position: relative;
    background: ${debug ? PRESCRIPTION_COLORS_MAP.bodyColor.color : 'unset'};
    display: flex;
    height: 100%;
    flex-direction: column;
    flex: 1;
    max-width: 100%;
    min-width: 0;
      @media print {
        // padding-top: ${headerHeight}px; /* Adjust this value to match the header height */
        // padding-bottom: ${footerHeight}px;
        margin: 0 !important; /* Remove default margin */
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        overflow: visible !important;
        // page-break-inside: avoid; /* Avoid breaking content inside the body */
        box-sizing: border-box !important;
      }
  `,
)

export const PMPConsultationParent = styled.div`
  @media screen {
    /* Clip content at the exact page boundary (set via inline height prop) so Firefox's
       incorrect height: 100% flex computation doesn't cause body to overflow into footer. */
    overflow: hidden;
  }
  @media print {
    ${'' /* display: block !important; */}// border-bottom: unset !important;;;;;;;;;;;;;
    /* Height and width will be controlled by dynamic CSS to maintain A4 aspect ratio */
    /* Removed conflicting height: auto !important to allow dynamic CSS to set exact A4 dimensions */
    overflow: visible !important;
    position: relative !important;
  }
  @page {
    size: A4 portrait; /* Page size and orientation */
    margin-top: 1in; /* Top, right, bottom, left */
  }
  border: ${(props) => (props?.noBorder ? '' : '1px solid rgba(0, 0, 0, 0.15)')};
  width: 100%;
  max-width: 794px;
  // min-height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box; /* Ensure borders are included in the width */
  font-size: ${({ biggerFont }) => (biggerFont ? '17px' : '12px')};
  background: #fff;
  color: #000;
`
export const PMPPrintWrapper = muiStyled('div')(
  ({ theme, showInUI }) => `
  height: ${showInUI ? 'unset' : '0px'};
  overflow: hidden;
  @media print {
    height: auto !important;
    overflow: visible !important;
    max-height: none !important;
    display: block !important;
  }
`,
)
